(function () {
  'use strict';

  /*
   * ============================================================
   * HIGHLAND MINT - GEO SPORTS PERSONALIZATION
   * FINAL PRESENTATION VERSION
   * ============================================================
   *
   * GEO / GEOSWAP / MARKET / QA / PRODUCT LOGIC:
   * UNCHANGED
   *
   * FINAL VISUAL CHANGES:
   * 1. Shop All Teams uses simple text pill buttons.
   * 2. NFL / MLB / NHL / NBA / College included.
   * 3. Not Your Team buttons = white + navy border.
   * 4. Hover = shadow only.
   * 5. Team buttons remain pill-shaped on mobile.
   * 6. Team logos remain beside team names.
   * ============================================================
   */


  /* ============================================================
     1. TEAM DATABASE
     ============================================================ */

  const TEAMS = {

    /* NFL */

    'arizona-cardinals': {
      name: 'Arizona Cardinals',
      handle: 'arizona-cardinals',
      league: 'NFL'
    },

    'atlanta-falcons': {
      name: 'Atlanta Falcons',
      handle: 'atlanta-falcons',
      league: 'NFL'
    },

    'baltimore-ravens': {
      name: 'Baltimore Ravens',
      handle: 'baltimore-ravens',
      league: 'NFL'
    },

    'buffalo-bills': {
      name: 'Buffalo Bills',
      handle: 'buffalo-bills',
      league: 'NFL'
    },

    'carolina-panthers': {
      name: 'Carolina Panthers',
      handle: 'carolina-panthers',
      league: 'NFL'
    },

    'chicago-bears': {
      name: 'Chicago Bears',
      handle: 'chicago-bears',
      league: 'NFL'
    },

    'cincinnati-bengals': {
      name: 'Cincinnati Bengals',
      handle: 'cincinnati-bengals',
      league: 'NFL'
    },

    'cleveland-browns': {
      name: 'Cleveland Browns',
      handle: 'cleveland-browns',
      league: 'NFL'
    },

    'dallas-cowboys': {
      name: 'Dallas Cowboys',
      handle: 'dallas-cowboys',
      league: 'NFL'
    },

    'denver-broncos': {
      name: 'Denver Broncos',
      handle: 'denver-broncos',
      league: 'NFL'
    },

    'detroit-lions': {
      name: 'Detroit Lions',
      handle: 'detroit-lions',
      league: 'NFL'
    },

    'green-bay-packers': {
      name: 'Green Bay Packers',
      handle: 'green-bay-packers',
      league: 'NFL'
    },

    'houston-texans': {
      name: 'Houston Texans',
      handle: 'houston-texans',
      league: 'NFL'
    },

    'indianapolis-colts': {
      name: 'Indianapolis Colts',
      handle: 'indianapolis-colts',
      league: 'NFL'
    },

    'jacksonville-jaguars': {
      name: 'Jacksonville Jaguars',
      handle: 'jacksonville-jaguars',
      league: 'NFL'
    },

    'kansas-city-chiefs': {
      name: 'Kansas City Chiefs',
      handle: 'kansas-city-chiefs',
      league: 'NFL'
    },

    'las-vegas-raiders': {
      name: 'Las Vegas Raiders',
      handle: 'las-vegas-raiders',
      league: 'NFL'
    },

    'los-angeles-chargers': {
      name: 'Los Angeles Chargers',
      handle: 'los-angeles-chargers',
      league: 'NFL'
    },

    'los-angeles-rams': {
      name: 'Los Angeles Rams',
      handle: 'los-angeles-rams',
      league: 'NFL'
    },

    'miami-dolphins': {
      name: 'Miami Dolphins',
      handle: 'miami-dolphins',
      league: 'NFL'
    },

    'minnesota-vikings': {
      name: 'Minnesota Vikings',
      handle: 'minnesota-vikings',
      league: 'NFL'
    },

    'new-england-patriots': {
      name: 'New England Patriots',
      handle: 'new-england-patriots',
      league: 'NFL'
    },

    'new-orleans-saints': {
      name: 'New Orleans Saints',
      handle: 'new-orleans-saints',
      league: 'NFL'
    },

    'new-york-giants': {
      name: 'New York Giants',
      handle: 'new-york-giants',
      league: 'NFL'
    },

    'new-york-jets': {
      name: 'New York Jets',
      handle: 'new-york-jets',
      league: 'NFL'
    },

    'philadelphia-eagles': {
      name: 'Philadelphia Eagles',
      handle: 'philadelphia-eagles',
      league: 'NFL'
    },

    'pittsburgh-steelers': {
      name: 'Pittsburgh Steelers',
      handle: 'pittsburgh-steelers',
      league: 'NFL'
    },

    'san-francisco-49ers': {
      name: 'San Francisco 49ers',
      handle: 'san-francisco-49ers',
      league: 'NFL'
    },

    'seattle-seahawks': {
      name: 'Seattle Seahawks',
      handle: 'seattle-seahawks',
      league: 'NFL'
    },

    'tampa-bay-buccaneers': {
      name: 'Tampa Bay Buccaneers',
      handle: 'tampa-bay-buccaneers',
      league: 'NFL'
    },

    'tennessee-titans': {
      name: 'Tennessee Titans',
      handle: 'tennessee-titans',
      league: 'NFL'
    },

    'washington-commanders': {
      name: 'Washington Commanders',
      handle: 'washington-commanders',
      league: 'NFL'
    },


    /* NBA */

    'atlanta-hawks': {
      name: 'Atlanta Hawks',
      handle: 'atlanta-hawks',
      league: 'NBA'
    },

    'boston-celtics': {
      name: 'Boston Celtics',
      handle: 'boston-celtics',
      league: 'NBA'
    },

    'brooklyn-nets': {
      name: 'Brooklyn Nets',
      handle: 'brooklyn-nets',
      league: 'NBA'
    },

    'charlotte-hornets': {
      name: 'Charlotte Hornets',
      handle: 'charlotte-hornets',
      league: 'NBA'
    },

    'chicago-bulls': {
      name: 'Chicago Bulls',
      handle: 'chicago-bulls',
      league: 'NBA'
    },

    'cleveland-cavaliers': {
      name: 'Cleveland Cavaliers',
      handle: 'cleveland-cavaliers',
      league: 'NBA'
    },

    'dallas-mavericks': {
      name: 'Dallas Mavericks',
      handle: 'dallas-mavericks',
      league: 'NBA'
    },

    'denver-nuggets': {
      name: 'Denver Nuggets',
      handle: 'denver-nuggets',
      league: 'NBA'
    },

    'detroit-pistons': {
      name: 'Detroit Pistons',
      handle: 'detroit-pistons',
      league: 'NBA'
    },

    'golden-state-warriors': {
      name: 'Golden State Warriors',
      handle: 'golden-state-warriors',
      league: 'NBA'
    },

    'houston-rockets': {
      name: 'Houston Rockets',
      handle: 'houston-rockets',
      league: 'NBA'
    },

    'indiana-pacers': {
      name: 'Indiana Pacers',
      handle: 'indiana-pacers',
      league: 'NBA'
    },

    'los-angeles-clippers': {
      name: 'Los Angeles Clippers',
      handle: 'los-angeles-clippers',
      league: 'NBA'
    },

    'los-angeles-lakers': {
      name: 'Los Angeles Lakers',
      handle: 'los-angeles-lakers',
      league: 'NBA'
    },

    'memphis-grizzlies': {
      name: 'Memphis Grizzlies',
      handle: 'memphis-grizzlies',
      league: 'NBA'
    },

    'miami-heat': {
      name: 'Miami Heat',
      handle: 'miami-heat',
      league: 'NBA'
    },

    'milwaukee-bucks': {
      name: 'Milwaukee Bucks',
      handle: 'milwaukee-bucks',
      league: 'NBA'
    },

    'minnesota-timberwolves': {
      name: 'Minnesota Timberwolves',
      handle: 'minnesota-timberwolves',
      league: 'NBA'
    },

    'new-orleans-pelicans': {
      name: 'New Orleans Pelicans',
      handle: 'new-orleans-pelicans',
      league: 'NBA'
    },

    'new-york-knicks': {
      name: 'New York Knicks',
      handle: 'new-york-knicks',
      league: 'NBA'
    },

    'oklahoma-city-thunder': {
      name: 'Oklahoma City Thunder',
      handle: 'oklahoma-city-thunder',
      league: 'NBA'
    },

    'orlando-magic': {
      name: 'Orlando Magic',
      handle: 'orlando-magic',
      league: 'NBA'
    },

    'philadelphia-76ers': {
      name: 'Philadelphia 76ers',
      handle: 'philadelphia-76ers',
      league: 'NBA'
    },

    'phoenix-suns': {
      name: 'Phoenix Suns',
      handle: 'phoenix-suns',
      league: 'NBA'
    },

    'portland-trail-blazers': {
      name: 'Portland Trail Blazers',
      handle: 'portland-trail-blazers',
      league: 'NBA'
    },

    'sacramento-kings': {
      name: 'Sacramento Kings',
      handle: 'sacramento-kings',
      league: 'NBA'
    },

    'san-antonio-spurs': {
      name: 'San Antonio Spurs',
      handle: 'san-antonio-spurs',
      league: 'NBA'
    },

    'toronto-raptors': {
      name: 'Toronto Raptors',
      handle: 'toronto-raptors',
      league: 'NBA'
    },

    'utah-jazz': {
      name: 'Utah Jazz',
      handle: 'utah-jazz',
      league: 'NBA'
    },

    'washington-wizards': {
      name: 'Washington Wizards',
      handle: 'washington-wizards',
      league: 'NBA'
    },


    /* MLB */

    'arizona-diamondbacks': {
      name: 'Arizona Diamondbacks',
      handle: 'arizona-diamondbacks',
      league: 'MLB'
    },

    'oakland-athletics': {
      name: 'Athletics',
      handle: 'oakland-athletics',
      league: 'MLB'
    },

    'atlanta-braves': {
      name: 'Atlanta Braves',
      handle: 'atlanta-braves',
      league: 'MLB'
    },

    'baltimore-orioles': {
      name: 'Baltimore Orioles',
      handle: 'baltimore-orioles',
      league: 'MLB'
    },

    'boston-red-sox': {
      name: 'Boston Red Sox',
      handle: 'boston-red-sox',
      league: 'MLB'
    },

    'chicago-cubs': {
      name: 'Chicago Cubs',
      handle: 'chicago-cubs',
      league: 'MLB'
    },

    'chicago-white-sox': {
      name: 'Chicago White Sox',
      handle: 'chicago-white-sox',
      league: 'MLB'
    },

    'cincinnati-reds': {
      name: 'Cincinnati Reds',
      handle: 'cincinnati-reds',
      league: 'MLB'
    },

    'cleveland-guardians': {
      name: 'Cleveland Guardians',
      handle: 'cleveland-guardians',
      league: 'MLB'
    },

    'colorado-rockies': {
      name: 'Colorado Rockies',
      handle: 'colorado-rockies',
      league: 'MLB'
    },

    'detroit-tigers': {
      name: 'Detroit Tigers',
      handle: 'detroit-tigers',
      league: 'MLB'
    },

    'houston-astros': {
      name: 'Houston Astros',
      handle: 'houston-astros',
      league: 'MLB'
    },

    'kansas-city-royals': {
      name: 'Kansas City Royals',
      handle: 'kansas-city-royals',
      league: 'MLB'
    },

    'los-angeles-angels': {
      name: 'Los Angeles Angels',
      handle: 'los-angeles-angels',
      league: 'MLB'
    },

    'los-angeles-dodgers': {
      name: 'Los Angeles Dodgers',
      handle: 'los-angeles-dodgers',
      league: 'MLB'
    },

    'miami-marlins': {
      name: 'Miami Marlins',
      handle: 'miami-marlins',
      league: 'MLB'
    },

    'milwaukee-brewers': {
      name: 'Milwaukee Brewers',
      handle: 'milwaukee-brewers',
      league: 'MLB'
    },

    'minnesota-twins': {
      name: 'Minnesota Twins',
      handle: 'minnesota-twins',
      league: 'MLB'
    },

    'new-york-mets': {
      name: 'New York Mets',
      handle: 'new-york-mets',
      league: 'MLB'
    },

    'new-york-yankees': {
      name: 'New York Yankees',
      handle: 'new-york-yankees',
      league: 'MLB'
    },

    'philadelphia-phillies': {
      name: 'Philadelphia Phillies',
      handle: 'philadelphia-phillies',
      league: 'MLB'
    },

    'pittsburgh-pirates': {
      name: 'Pittsburgh Pirates',
      handle: 'pittsburgh-pirates',
      league: 'MLB'
    },

    'san-diego-padres': {
      name: 'San Diego Padres',
      handle: 'san-diego-padres',
      league: 'MLB'
    },

    'san-francisco-giants': {
      name: 'San Francisco Giants',
      handle: 'san-francisco-giants',
      league: 'MLB'
    },

    'seattle-mariners': {
      name: 'Seattle Mariners',
      handle: 'seattle-mariners',
      league: 'MLB'
    },

    'st-louis-cardinals': {
      name: 'St. Louis Cardinals',
      handle: 'st-louis-cardinals',
      league: 'MLB'
    },

    'tampa-bay-rays': {
      name: 'Tampa Bay Rays',
      handle: 'tampa-bay-rays',
      league: 'MLB'
    },

    'texas-rangers': {
      name: 'Texas Rangers',
      handle: 'texas-rangers',
      league: 'MLB'
    },

    'toronto-blue-jays': {
      name: 'Toronto Blue Jays',
      handle: 'toronto-blue-jays',
      league: 'MLB'
    },

    'washington-nationals': {
      name: 'Washington Nationals',
      handle: 'washington-nationals',
      league: 'MLB'
    },


    /* NHL */

    'anaheim-ducks': {
      name: 'Anaheim Ducks',
      handle: 'anaheim-ducks',
      league: 'NHL'
    },

    'boston-bruins': {
      name: 'Boston Bruins',
      handle: 'boston-bruins',
      league: 'NHL'
    },

    'buffalo-sabres': {
      name: 'Buffalo Sabres',
      handle: 'buffalo-sabres',
      league: 'NHL'
    },

    'calgary-flames': {
      name: 'Calgary Flames',
      handle: 'calgary-flames',
      league: 'NHL'
    },

    'carolina-hurricanes': {
      name: 'Carolina Hurricanes',
      handle: 'carolina-hurricanes',
      league: 'NHL'
    },

    'chicago-blackhawks': {
      name: 'Chicago Blackhawks',
      handle: 'chicago-blackhawks',
      league: 'NHL'
    },

    'colorado-avalanche': {
      name: 'Colorado Avalanche',
      handle: 'colorado-avalanche',
      league: 'NHL'
    },

    'columbus-blue-jackets': {
      name: 'Columbus Blue Jackets',
      handle: 'columbus-blue-jackets',
      league: 'NHL'
    },

    'dallas-stars': {
      name: 'Dallas Stars',
      handle: 'dallas-stars',
      league: 'NHL'
    },

    'detroit-red-wings': {
      name: 'Detroit Red Wings',
      handle: 'detroit-red-wings',
      league: 'NHL'
    },

    'edmonton-oilers': {
      name: 'Edmonton Oilers',
      handle: 'edmonton-oilers',
      league: 'NHL'
    },

    'florida-panthers': {
      name: 'Florida Panthers',
      handle: 'florida-panthers',
      league: 'NHL'
    },

    'los-angeles-kings': {
      name: 'Los Angeles Kings',
      handle: 'los-angeles-kings',
      league: 'NHL'
    },

    'minnesota-wild': {
      name: 'Minnesota Wild',
      handle: 'minnesota-wild',
      league: 'NHL'
    },

    'montreal-canadiens': {
      name: 'Montreal Canadiens',
      handle: 'montreal-canadiens',
      league: 'NHL'
    },

    'nashville-predators': {
      name: 'Nashville Predators',
      handle: 'nashville-predators',
      league: 'NHL'
    },

    'new-jersey-devils': {
      name: 'New Jersey Devils',
      handle: 'new-jersey-devils',
      league: 'NHL'
    },

    'new-york-islanders': {
      name: 'New York Islanders',
      handle: 'new-york-islanders',
      league: 'NHL'
    },

    'new-york-rangers': {
      name: 'New York Rangers',
      handle: 'new-york-rangers',
      league: 'NHL'
    },

    'ottawa-senators': {
      name: 'Ottawa Senators',
      handle: 'ottawa-senators',
      league: 'NHL'
    },

    'philadelphia-flyers': {
      name: 'Philadelphia Flyers',
      handle: 'philadelphia-flyers',
      league: 'NHL'
    },

    'pittsburgh-penguins': {
      name: 'Pittsburgh Penguins',
      handle: 'pittsburgh-penguins',
      league: 'NHL'
    },

    'san-jose-sharks': {
      name: 'San Jose Sharks',
      handle: 'san-jose-sharks',
      league: 'NHL'
    },

    'seattle-kraken': {
      name: 'Seattle Kraken',
      handle: 'seattle-kraken',
      league: 'NHL'
    },

    'st-louis-blues': {
      name: 'St. Louis Blues',
      handle: 'st-louis-blues',
      league: 'NHL'
    },

    'tampa-bay-lightning': {
      name: 'Tampa Bay Lightning',
      handle: 'tampa-bay-lightning',
      league: 'NHL'
    },

    'toronto-maple-leafs': {
      name: 'Toronto Maple Leafs',
      handle: 'toronto-maple-leafs',
      league: 'NHL'
    },

    'utah-mammoth': {
      name: 'Utah Mammoth',
      handle: 'utah-mammoth',
      league: 'NHL'
    },

    'vancouver-canucks': {
      name: 'Vancouver Canucks',
      handle: 'vancouver-canucks',
      league: 'NHL'
    },

    'vegas-golden-knights': {
      name: 'Vegas Golden Knights',
      handle: 'vegas-golden-knights',
      league: 'NHL'
    },

    'washington-capitals': {
      name: 'Washington Capitals',
      handle: 'washington-capitals',
      league: 'NHL'
    },

    'winnipeg-jets': {
      name: 'Winnipeg Jets',
      handle: 'winnipeg-jets',
      league: 'NHL'
    }

  };


  /* ============================================================
     2. SPORTS MARKETS
     ============================================================ */

  const SPORTS_MARKETS = {

    'south-florida': {
      label: 'South Florida',
      primary: 'miami-dolphins',
      teams: [
        'miami-dolphins',
        'miami-heat',
        'miami-marlins',
        'florida-panthers',
        'orlando-magic',
        'tampa-bay-buccaneers',
        'tampa-bay-rays',
        'tampa-bay-lightning',
        'jacksonville-jaguars'
      ]
    },

    'orlando': {
      label: 'Central Florida',
      primary: 'orlando-magic',
      teams: [
        'orlando-magic',
        'miami-dolphins',
        'miami-heat',
        'miami-marlins',
        'florida-panthers',
        'tampa-bay-buccaneers',
        'tampa-bay-rays',
        'tampa-bay-lightning',
        'jacksonville-jaguars'
      ]
    },

    'tampa-bay': {
      label: 'Tampa Bay',
      primary: 'tampa-bay-buccaneers',
      teams: [
        'tampa-bay-buccaneers',
        'tampa-bay-rays',
        'tampa-bay-lightning',
        'orlando-magic',
        'miami-dolphins',
        'miami-heat',
        'florida-panthers',
        'jacksonville-jaguars'
      ]
    },

    'jacksonville': {
      label: 'Northeast Florida',
      primary: 'jacksonville-jaguars',
      teams: [
        'jacksonville-jaguars',
        'orlando-magic',
        'tampa-bay-buccaneers',
        'tampa-bay-lightning',
        'miami-dolphins',
        'miami-heat',
        'florida-panthers'
      ]
    },

    'florida-state': {
      label: 'Florida',
      primary: 'orlando-magic',
      teams: [
        'orlando-magic',
        'miami-dolphins',
        'miami-heat',
        'miami-marlins',
        'florida-panthers',
        'tampa-bay-buccaneers',
        'tampa-bay-rays',
        'tampa-bay-lightning',
        'jacksonville-jaguars'
      ]
    },

    'boston': {
      label: 'New England',
      primary: 'new-england-patriots',
      teams: [
        'new-england-patriots',
        'boston-celtics',
        'boston-red-sox',
        'boston-bruins'
      ]
    },

    'nyc-metro': {
      label: 'New York Metro',
      primary: 'new-york-yankees',
      teams: [
        'new-york-yankees',
        'new-york-mets',
        'new-york-giants',
        'new-york-jets',
        'new-york-knicks',
        'brooklyn-nets',
        'new-york-rangers',
        'new-york-islanders',
        'new-jersey-devils'
      ]
    },

    'buffalo': {
      label: 'Western New York',
      primary: 'buffalo-bills',
      teams: [
        'buffalo-bills',
        'buffalo-sabres'
      ]
    },

    'philadelphia': {
      label: 'Philadelphia',
      primary: 'philadelphia-eagles',
      teams: [
        'philadelphia-eagles',
        'philadelphia-76ers',
        'philadelphia-phillies',
        'philadelphia-flyers'
      ]
    },

    'pittsburgh': {
      label: 'Pittsburgh',
      primary: 'pittsburgh-steelers',
      teams: [
        'pittsburgh-steelers',
        'pittsburgh-pirates',
        'pittsburgh-penguins'
      ]
    },

    'washington-dc': {
      label: 'Washington, DC',
      primary: 'washington-commanders',
      teams: [
        'washington-commanders',
        'washington-wizards',
        'washington-nationals',
        'washington-capitals',
        'baltimore-ravens',
        'baltimore-orioles'
      ]
    },

    'baltimore': {
      label: 'Baltimore',
      primary: 'baltimore-ravens',
      teams: [
        'baltimore-ravens',
        'baltimore-orioles',
        'washington-commanders',
        'washington-nationals',
        'washington-capitals'
      ]
    },

    'atlanta': {
      label: 'Atlanta',
      primary: 'atlanta-falcons',
      teams: [
        'atlanta-falcons',
        'atlanta-hawks',
        'atlanta-braves'
      ]
    },

    'charlotte': {
      label: 'Charlotte / Carolinas',
      primary: 'carolina-panthers',
      teams: [
        'carolina-panthers',
        'charlotte-hornets',
        'carolina-hurricanes'
      ]
    },

    'raleigh': {
      label: 'Raleigh / Triangle',
      primary: 'carolina-hurricanes',
      teams: [
        'carolina-hurricanes',
        'carolina-panthers',
        'charlotte-hornets'
      ]
    },

    'nashville': {
      label: 'Nashville',
      primary: 'tennessee-titans',
      teams: [
        'tennessee-titans',
        'nashville-predators',
        'memphis-grizzlies'
      ]
    },

    'memphis': {
      label: 'Memphis',
      primary: 'memphis-grizzlies',
      teams: [
        'memphis-grizzlies',
        'tennessee-titans',
        'nashville-predators'
      ]
    },

    'new-orleans': {
      label: 'New Orleans',
      primary: 'new-orleans-saints',
      teams: [
        'new-orleans-saints',
        'new-orleans-pelicans'
      ]
    },

    'chicago': {
      label: 'Chicago',
      primary: 'chicago-bears',
      teams: [
        'chicago-bears',
        'chicago-bulls',
        'chicago-cubs',
        'chicago-white-sox',
        'chicago-blackhawks'
      ]
    },

    'detroit': {
      label: 'Detroit',
      primary: 'detroit-lions',
      teams: [
        'detroit-lions',
        'detroit-pistons',
        'detroit-tigers',
        'detroit-red-wings'
      ]
    },

    'cleveland': {
      label: 'Cleveland',
      primary: 'cleveland-browns',
      teams: [
        'cleveland-browns',
        'cleveland-cavaliers',
        'cleveland-guardians',
        'columbus-blue-jackets'
      ]
    },

    'cincinnati': {
      label: 'Cincinnati',
      primary: 'cincinnati-bengals',
      teams: [
        'cincinnati-bengals',
        'cincinnati-reds',
        'columbus-blue-jackets'
      ]
    },

    'columbus': {
      label: 'Columbus',
      primary: 'columbus-blue-jackets',
      teams: [
        'columbus-blue-jackets',
        'cleveland-browns',
        'cleveland-cavaliers',
        'cleveland-guardians',
        'cincinnati-bengals',
        'cincinnati-reds'
      ]
    },

    'minneapolis': {
      label: 'Minnesota',
      primary: 'minnesota-vikings',
      teams: [
        'minnesota-vikings',
        'minnesota-timberwolves',
        'minnesota-twins',
        'minnesota-wild'
      ]
    },

    'milwaukee': {
      label: 'Wisconsin',
      primary: 'green-bay-packers',
      teams: [
        'green-bay-packers',
        'milwaukee-bucks',
        'milwaukee-brewers'
      ]
    },

    'indianapolis': {
      label: 'Indianapolis',
      primary: 'indianapolis-colts',
      teams: [
        'indianapolis-colts',
        'indiana-pacers'
      ]
    },

    'kansas-city': {
      label: 'Kansas City',
      primary: 'kansas-city-chiefs',
      teams: [
        'kansas-city-chiefs',
        'kansas-city-royals'
      ]
    },

    'st-louis': {
      label: 'St. Louis',
      primary: 'st-louis-cardinals',
      teams: [
        'st-louis-cardinals',
        'st-louis-blues'
      ]
    },

    'oklahoma-city': {
      label: 'Oklahoma',
      primary: 'oklahoma-city-thunder',
      teams: [
        'oklahoma-city-thunder'
      ]
    },

    'dallas-fort-worth': {
      label: 'Dallas-Fort Worth',
      primary: 'dallas-cowboys',
      teams: [
        'dallas-cowboys',
        'dallas-mavericks',
        'texas-rangers',
        'dallas-stars'
      ]
    },

    'houston': {
      label: 'Houston',
      primary: 'houston-texans',
      teams: [
        'houston-texans',
        'houston-rockets',
        'houston-astros'
      ]
    },

    'san-antonio': {
      label: 'San Antonio / Central Texas',
      primary: 'san-antonio-spurs',
      teams: [
        'san-antonio-spurs',
        'dallas-cowboys',
        'houston-texans',
        'houston-rockets',
        'houston-astros'
      ]
    },

    'texas-state': {
      label: 'Texas',
      primary: 'dallas-cowboys',
      teams: [
        'dallas-cowboys',
        'dallas-mavericks',
        'texas-rangers',
        'dallas-stars',
        'houston-texans',
        'houston-rockets',
        'houston-astros',
        'san-antonio-spurs'
      ]
    },

    'phoenix': {
      label: 'Arizona',
      primary: 'arizona-cardinals',
      teams: [
        'arizona-cardinals',
        'phoenix-suns',
        'arizona-diamondbacks'
      ]
    },

    'denver': {
      label: 'Colorado',
      primary: 'denver-broncos',
      teams: [
        'denver-broncos',
        'denver-nuggets',
        'colorado-rockies',
        'colorado-avalanche'
      ]
    },

    'salt-lake-city': {
      label: 'Utah',
      primary: 'utah-jazz',
      teams: [
        'utah-jazz',
        'utah-mammoth'
      ]
    },

    'las-vegas': {
      label: 'Las Vegas',
      primary: 'las-vegas-raiders',
      teams: [
        'las-vegas-raiders',
        'vegas-golden-knights'
      ]
    },

    'los-angeles': {
      label: 'Los Angeles',
      primary: 'los-angeles-dodgers',
      teams: [
        'los-angeles-dodgers',
        'los-angeles-lakers',
        'los-angeles-rams',
        'los-angeles-chargers',
        'los-angeles-clippers',
        'los-angeles-kings',
        'los-angeles-angels',
        'anaheim-ducks'
      ]
    },

    'orange-county': {
      label: 'Orange County',
      primary: 'los-angeles-angels',
      teams: [
        'los-angeles-angels',
        'anaheim-ducks',
        'los-angeles-dodgers',
        'los-angeles-lakers',
        'los-angeles-rams',
        'los-angeles-chargers',
        'los-angeles-clippers',
        'los-angeles-kings'
      ]
    },

    'san-diego': {
      label: 'San Diego',
      primary: 'san-diego-padres',
      teams: [
        'san-diego-padres',
        'los-angeles-dodgers',
        'los-angeles-lakers',
        'los-angeles-rams',
        'los-angeles-chargers'
      ]
    },

    'bay-area': {
      label: 'San Francisco Bay Area',
      primary: 'san-francisco-49ers',
      teams: [
        'san-francisco-49ers',
        'golden-state-warriors',
        'san-francisco-giants',
        'san-jose-sharks'
      ]
    },

    'sacramento': {
      label: 'Sacramento',
      primary: 'sacramento-kings',
      teams: [
        'sacramento-kings',
        'oakland-athletics',
        'san-francisco-49ers',
        'golden-state-warriors',
        'san-francisco-giants',
        'san-jose-sharks'
      ]
    },

    'seattle': {
      label: 'Seattle / Pacific Northwest',
      primary: 'seattle-seahawks',
      teams: [
        'seattle-seahawks',
        'seattle-mariners',
        'seattle-kraken'
      ]
    },

    'portland': {
      label: 'Portland',
      primary: 'portland-trail-blazers',
      teams: [
        'portland-trail-blazers',
        'seattle-seahawks',
        'seattle-mariners',
        'seattle-kraken'
      ]
    },

    'toronto': {
      label: 'Toronto',
      primary: 'toronto-maple-leafs',
      teams: [
        'toronto-maple-leafs',
        'toronto-raptors',
        'toronto-blue-jays',
        'ottawa-senators'
      ]
    },

    'ottawa': {
      label: 'Ottawa',
      primary: 'ottawa-senators',
      teams: [
        'ottawa-senators',
        'toronto-maple-leafs',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    },

    'montreal': {
      label: 'Montreal / Quebec',
      primary: 'montreal-canadiens',
      teams: [
        'montreal-canadiens',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    },

    'vancouver': {
      label: 'Vancouver',
      primary: 'vancouver-canucks',
      teams: [
        'vancouver-canucks',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    },

    'calgary': {
      label: 'Calgary',
      primary: 'calgary-flames',
      teams: [
        'calgary-flames',
        'edmonton-oilers',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    },

    'edmonton': {
      label: 'Edmonton',
      primary: 'edmonton-oilers',
      teams: [
        'edmonton-oilers',
        'calgary-flames',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    },

    'winnipeg': {
      label: 'Winnipeg / Manitoba',
      primary: 'winnipeg-jets',
      teams: [
        'winnipeg-jets',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    },

    'canada-fallback': {
      label: 'Canada',
      primary: 'toronto-maple-leafs',
      teams: [
        'toronto-maple-leafs',
        'montreal-canadiens',
        'vancouver-canucks',
        'edmonton-oilers',
        'calgary-flames',
        'ottawa-senators',
        'winnipeg-jets',
        'toronto-raptors',
        'toronto-blue-jays'
      ]
    }

  };


  /* ============================================================
     3. CITY / METRO MATCHING
     ============================================================ */

  const LOCATION_TO_MARKET = {

    'FL|miami': 'south-florida',
    'FL|fort lauderdale': 'south-florida',
    'FL|west palm beach': 'south-florida',
    'FL|boca raton': 'south-florida',
    'FL|hollywood': 'south-florida',

    'FL|orlando': 'orlando',
    'FL|melbourne': 'orlando',
    'FL|palm bay': 'orlando',
    'FL|kissimmee': 'orlando',
    'FL|winter park': 'orlando',
    'FL|daytona beach': 'orlando',

    'FL|tampa': 'tampa-bay',
    'FL|clearwater': 'tampa-bay',
    'FL|st. petersburg': 'tampa-bay',
    'FL|saint petersburg': 'tampa-bay',
    'FL|sarasota': 'tampa-bay',
    'FL|lakeland': 'tampa-bay',

    'FL|jacksonville': 'jacksonville',
    'FL|st. augustine': 'jacksonville',
    'FL|saint augustine': 'jacksonville',

    'NY|new york': 'nyc-metro',
    'NY|brooklyn': 'nyc-metro',
    'NY|queens': 'nyc-metro',
    'NY|bronx': 'nyc-metro',
    'NY|staten island': 'nyc-metro',
    'NY|yonkers': 'nyc-metro',

    'NJ|newark': 'nyc-metro',
    'NJ|jersey city': 'nyc-metro',
    'NJ|hoboken': 'nyc-metro',

    'NY|buffalo': 'buffalo',
    'NY|rochester': 'buffalo',

    'MA|boston': 'boston',
    'MA|cambridge': 'boston',
    'MA|worcester': 'boston',
    'RI|providence': 'boston',
    'CT|hartford': 'boston',

    'PA|philadelphia': 'philadelphia',
    'PA|allentown': 'philadelphia',
    'PA|reading': 'philadelphia',

    'PA|pittsburgh': 'pittsburgh',
    'PA|erie': 'pittsburgh',

    'DC|washington': 'washington-dc',
    'VA|arlington': 'washington-dc',
    'VA|alexandria': 'washington-dc',

    'MD|baltimore': 'baltimore',

    'GA|atlanta': 'atlanta',
    'GA|marietta': 'atlanta',

    'NC|charlotte': 'charlotte',
    'NC|raleigh': 'raleigh',
    'NC|durham': 'raleigh',

    'TN|nashville': 'nashville',
    'TN|memphis': 'memphis',

    'LA|new orleans': 'new-orleans',

    'IL|chicago': 'chicago',

    'MI|detroit': 'detroit',

    'OH|cleveland': 'cleveland',
    'OH|cincinnati': 'cincinnati',
    'OH|columbus': 'columbus',

    'MN|minneapolis': 'minneapolis',
    'MN|saint paul': 'minneapolis',
    'MN|st. paul': 'minneapolis',

    'WI|milwaukee': 'milwaukee',
    'WI|green bay': 'milwaukee',

    'IN|indianapolis': 'indianapolis',

    'MO|kansas city': 'kansas-city',
    'KS|kansas city': 'kansas-city',
    'KS|overland park': 'kansas-city',

    'MO|st. louis': 'st-louis',
    'MO|saint louis': 'st-louis',

    'OK|oklahoma city': 'oklahoma-city',

    'TX|dallas': 'dallas-fort-worth',
    'TX|fort worth': 'dallas-fort-worth',
    'TX|arlington': 'dallas-fort-worth',
    'TX|plano': 'dallas-fort-worth',
    'TX|frisco': 'dallas-fort-worth',

    'TX|houston': 'houston',

    'TX|san antonio': 'san-antonio',
    'TX|austin': 'san-antonio',

    'AZ|phoenix': 'phoenix',
    'AZ|scottsdale': 'phoenix',
    'AZ|mesa': 'phoenix',

    'CO|denver': 'denver',
    'CO|aurora': 'denver',
    'CO|boulder': 'denver',

    'UT|salt lake city': 'salt-lake-city',

    'NV|las vegas': 'las-vegas',

    'CA|los angeles': 'los-angeles',
    'CA|long beach': 'los-angeles',
    'CA|pasadena': 'los-angeles',

    'CA|anaheim': 'orange-county',
    'CA|irvine': 'orange-county',
    'CA|santa ana': 'orange-county',

    'CA|san diego': 'san-diego',

    'CA|san francisco': 'bay-area',
    'CA|oakland': 'bay-area',
    'CA|san jose': 'bay-area',

    'CA|sacramento': 'sacramento',

    'WA|seattle': 'seattle',
    'WA|tacoma': 'seattle',

    'OR|portland': 'portland',

    'ON|toronto': 'toronto',
    'ON|mississauga': 'toronto',
    'ON|brampton': 'toronto',
    'ON|hamilton': 'toronto',

    'ON|ottawa': 'ottawa',

    'QC|montreal': 'montreal',
    'QC|laval': 'montreal',
    'QC|quebec city': 'montreal',

    'BC|vancouver': 'vancouver',
    'BC|burnaby': 'vancouver',
    'BC|surrey': 'vancouver',
    'BC|victoria': 'vancouver',

    'AB|calgary': 'calgary',
    'AB|edmonton': 'edmonton',

    'MB|winnipeg': 'winnipeg'

  };


  /* ============================================================
     4. US STATE FALLBACKS
     ============================================================ */

  const US_STATE_FALLBACK = {

    AL: 'atlanta',
    AK: 'seattle',
    AZ: 'phoenix',
    AR: 'memphis',
    CA: 'los-angeles',
    CO: 'denver',
    CT: 'boston',
    DE: 'philadelphia',
    DC: 'washington-dc',
    FL: 'florida-state',
    GA: 'atlanta',
    HI: 'los-angeles',
    ID: 'salt-lake-city',
    IL: 'chicago',
    IN: 'indianapolis',
    IA: 'kansas-city',
    KS: 'kansas-city',
    KY: 'cincinnati',
    LA: 'new-orleans',
    ME: 'boston',
    MD: 'baltimore',
    MA: 'boston',
    MI: 'detroit',
    MN: 'minneapolis',
    MS: 'new-orleans',
    MO: 'kansas-city',
    MT: 'denver',
    NE: 'kansas-city',
    NV: 'las-vegas',
    NH: 'boston',
    NJ: 'nyc-metro',
    NM: 'phoenix',
    NY: 'nyc-metro',
    NC: 'charlotte',
    ND: 'minneapolis',
    OH: 'cleveland',
    OK: 'oklahoma-city',
    OR: 'portland',
    PA: 'philadelphia',
    RI: 'boston',
    SC: 'charlotte',
    SD: 'minneapolis',
    TN: 'nashville',
    TX: 'texas-state',
    UT: 'salt-lake-city',
    VT: 'boston',
    VA: 'washington-dc',
    WA: 'seattle',
    WV: 'pittsburgh',
    WI: 'milwaukee',
    WY: 'denver'

  };


  /* ============================================================
     5. CANADA PROVINCE FALLBACKS
     ============================================================ */

  const CA_PROVINCE_FALLBACK = {

    AB: 'edmonton',
    BC: 'vancouver',
    MB: 'winnipeg',

    NB: 'canada-fallback',
    NL: 'canada-fallback',
    NS: 'canada-fallback',
    NT: 'canada-fallback',
    NU: 'canada-fallback',

    ON: 'toronto',

    PE: 'canada-fallback',

    QC: 'montreal',

    SK: 'canada-fallback',

    YT: 'canada-fallback'

  };


  /* ============================================================
     6. QA SHORTCUTS
     ============================================================ */

  const QA_LOCATIONS = {

    dallas: {
      city: 'Dallas',
      state: 'TX',
      country: 'US',
      market: 'dallas-fort-worth'
    },

    toronto: {
      city: 'Toronto',
      state: 'ON',
      country: 'CA',
      market: 'toronto'
    },

    newyork: {
      city: 'New York',
      state: 'NY',
      country: 'US',
      market: 'nyc-metro'
    },

    losangeles: {
      city: 'Los Angeles',
      state: 'CA',
      country: 'US',
      market: 'los-angeles'
    },

    chicago: {
      city: 'Chicago',
      state: 'IL',
      country: 'US',
      market: 'chicago'
    },

    seattle: {
      city: 'Seattle',
      state: 'WA',
      country: 'US',
      market: 'seattle'
    },

    miami: {
      city: 'Miami',
      state: 'FL',
      country: 'US',
      market: 'south-florida'
    },

    tampa: {
      city: 'Tampa',
      state: 'FL',
      country: 'US',
      market: 'tampa-bay'
    },

    boston: {
      city: 'Boston',
      state: 'MA',
      country: 'US',
      market: 'boston'
    },

    philadelphia: {
      city: 'Philadelphia',
      state: 'PA',
      country: 'US',
      market: 'philadelphia'
    },

    atlanta: {
      city: 'Atlanta',
      state: 'GA',
      country: 'US',
      market: 'atlanta'
    },

    denver: {
      city: 'Denver',
      state: 'CO',
      country: 'US',
      market: 'denver'
    },

    phoenix: {
      city: 'Phoenix',
      state: 'AZ',
      country: 'US',
      market: 'phoenix'
    },

    sanfrancisco: {
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      market: 'bay-area'
    },

    houston: {
      city: 'Houston',
      state: 'TX',
      country: 'US',
      market: 'houston'
    },

    kansascity: {
      city: 'Kansas City',
      state: 'MO',
      country: 'US',
      market: 'kansas-city'
    },

    detroit: {
      city: 'Detroit',
      state: 'MI',
      country: 'US',
      market: 'detroit'
    },

    minneapolis: {
      city: 'Minneapolis',
      state: 'MN',
      country: 'US',
      market: 'minneapolis'
    },

    vancouver: {
      city: 'Vancouver',
      state: 'BC',
      country: 'CA',
      market: 'vancouver'
    },

    montreal: {
      city: 'Montreal',
      state: 'QC',
      country: 'CA',
      market: 'montreal'
    },

    edmonton: {
      city: 'Edmonton',
      state: 'AB',
      country: 'CA',
      market: 'edmonton'
    },

    calgary: {
      city: 'Calgary',
      state: 'AB',
      country: 'CA',
      market: 'calgary'
    },

    ottawa: {
      city: 'Ottawa',
      state: 'ON',
      country: 'CA',
      market: 'ottawa'
    }

  };


  /* ============================================================
     7. SHOP ALL LEAGUES
     ============================================================ */

  const LEAGUE_LINKS = [

    {
      name: 'NFL',
      url: '/pages/nfl'
    },

    {
      name: 'MLB',
      url: '/pages/mlb'
    },

    {
      name: 'NHL',
      url: '/pages/nhl'
    },

    {
      name: 'NBA',
      url: '/pages/nba'
    },

    {
      name: 'College',
      url: '/pages/clc'
    }

  ];


  /* ============================================================
     8. LOCATION
     ============================================================ */

  function normalizeCity(city) {

    return String(city || '')
      .toLowerCase()
      .trim();

  }


  function getLocationData() {

    const params =
      new URLSearchParams(
        window.location.search
      );


    const qa =
      String(
        params.get('qa') || ''
      )
        .toLowerCase()
        .trim();


    if (
      qa &&
      QA_LOCATIONS[qa]
    ) {

      console.log(
        'HM GEO QA MODE:',
        QA_LOCATIONS[qa]
      );


      return QA_LOCATIONS[qa];

    }


    const testCity =
      params.get('testCity');

    const testState =
      params.get('testState');

    const testCountry =
      params.get('testCountry');


    if (
      testCity &&
      testState &&
      testCountry
    ) {

      return {

        city: testCity,

        state:
          String(
            testState
          ).toUpperCase(),

        country:
          String(
            testCountry
          ).toUpperCase(),

        market: null

      };

    }


    const geoKey =
      Object.keys(
        sessionStorage
      )
        .find(function (key) {

          return (
            key.indexOf(
              'gs_vars_'
            ) === 0
          );

        });


    if (!geoKey) {

      return null;

    }


    try {

      const savedData =
        JSON.parse(
          sessionStorage.getItem(
            geoKey
          )
        );


      if (
        !savedData ||
        !savedData.data
      ) {

        return null;

      }


      return {

        city:
          String(
            savedData.data.city_name ||
            ''
          ),

        state:
          String(
            savedData.data.region_code ||
            ''
          ).toUpperCase(),

        country:
          String(
            savedData.data.country_code ||
            ''
          ).toUpperCase(),

        market:
          null

      };


    } catch (error) {

      console.error(
        'HM Geo: GeoSwap read failed.',
        error
      );


      return null;

    }

  }


  /* ============================================================
     9. RESOLVE MARKET
     ============================================================ */

  function resolveMarket(location) {

    if (!location) {

      return null;

    }


    if (
      location.market &&
      SPORTS_MARKETS[
        location.market
      ]
    ) {

      return location.market;

    }


    const cityKey =
      location.state +
      '|' +
      normalizeCity(
        location.city
      );


    if (
      LOCATION_TO_MARKET[
        cityKey
      ]
    ) {

      return (
        LOCATION_TO_MARKET[
          cityKey
        ]
      );

    }


    if (
      location.country === 'US'
    ) {

      return (
        US_STATE_FALLBACK[
          location.state
        ] ||
        null
      );

    }


    if (
      location.country === 'CA'
    ) {

      return (
        CA_PROVINCE_FALLBACK[
          location.state
        ] ||
        'canada-fallback'
      );

    }


    return null;

  }


  /* ============================================================
     10. PRODUCT HELPERS
     ============================================================ */

  function formatMoney(price) {

    const amount =
      Number(price || 0);


    return new Intl.NumberFormat(
      'en-US',
      {
        style: 'currency',
        currency: 'USD'
      }
    ).format(amount);

  }


  function getProductImage(product) {

    if (
      product &&
      product.images &&
      product.images.length &&
      product.images[0] &&
      product.images[0].src
    ) {

      return product.images[0].src;

    }


    return '';

  }


  function getProductPrice(product) {

    if (
      product &&
      product.variants &&
      product.variants.length &&
      product.variants[0]
    ) {

      return product.variants[0].price;

    }


    return '0';

  }


  async function fetchCollectionProducts(
    handle
  ) {

    const response =
      await fetch(
        '/collections/' +
        encodeURIComponent(
          handle
        ) +
        '/products.json?limit=6',
        {
          credentials:
            'same-origin'
        }
      );


    if (!response.ok) {

      throw new Error(
        'Collection failed: ' +
        handle
      );

    }


    const data =
      await response.json();


    return data.products || [];

  }


  /* ============================================================
     11. TEAM LOGOS
     ============================================================ */

  function getTeamLogoUrl(team) {

    return (
      '/cdn/shop/files/' +
      'header-link-team-icon-' +
      team.handle +
      '.png'
    );

  }


  /* ============================================================
     12. HTML BUILDERS
     ============================================================ */

  function buildProductCards(
    products
  ) {

    return products
      .map(function (product) {

        const image =
          getProductImage(
            product
          );

        const price =
          getProductPrice(
            product
          );


        return `

          <a
            class="hm-geo-product-card"
            href="/products/${product.handle}"
          >

            <div
              class="hm-geo-product-image-frame"
            >

              ${
                image
                  ? `
                    <img
                      class="hm-geo-product-image"
                      src="${image}"
                      alt="${product.title}"
                      loading="lazy"
                    >
                  `
                  : ''
              }

            </div>


            <div
              class="hm-geo-product-info"
            >

              <div
                class="hm-geo-product-title"
              >
                ${product.title}
              </div>


              <div
                class="hm-geo-product-price"
              >
                ${formatMoney(price)}
              </div>

            </div>

          </a>

        `;

      })
      .join('');

  }


  function getMarketTeams(
    market
  ) {

    return market.teams
      .map(function (teamKey) {

        return TEAMS[teamKey];

      })
      .filter(Boolean);

  }


  function buildTeamButtons(
    teams,
    primaryHandle
  ) {

    return teams
      .filter(function (team) {

        return (
          team.handle !==
          primaryHandle
        );

      })
      .map(function (team) {

        return `

          <a
            class="hm-geo-team-button"
            href="/collections/${team.handle}"
            aria-label="Shop ${team.name}"
          >

            <span
              class="hm-geo-team-logo-wrap"
            >

              <img
                class="hm-geo-team-logo"
                src="${getTeamLogoUrl(team)}"
                alt=""
                loading="lazy"
                onerror="this.style.display='none'"
              >

            </span>


            <span
              class="hm-geo-team-name"
            >
              ${team.name}
            </span>

          </a>

        `;

      })
      .join('');

  }


  function buildLeagueButtons() {

    return LEAGUE_LINKS
      .map(function (league) {

        return `

          <a
            class="hm-geo-league-button"
            href="${league.url}"
            aria-label="Shop ${league.name} teams"
          >
            ${league.name}
          </a>

        `;

      })
      .join('');

  }


  /* ============================================================
     13. GENERIC FALLBACK
     ============================================================ */

  function renderGenericFallback(
    container
  ) {

    container.innerHTML = `

      <div
        class="hm-geo-wrapper hm-geo-generic"
      >

        <section
          class="hm-geo-shop-all"
        >

          <h2>
            Shop Your Teams
          </h2>

          <p>
            Explore official collectibles from your favorite teams.
          </p>


          <div
            class="hm-geo-league-grid"
          >
            ${buildLeagueButtons()}
          </div>

        </section>

      </div>

    `;


    container.classList.remove(
      'geoswap-hide'
    );

  }


  /* ============================================================
     14. MARKET RENDER
     ============================================================ */

  async function renderMarket(
    container,
    marketKey
  ) {

    const market =
      SPORTS_MARKETS[
        marketKey
      ];


    if (!market) {

      renderGenericFallback(
        container
      );

      return;

    }


    const primaryTeam =
      TEAMS[
        market.primary
      ];


    if (!primaryTeam) {

      renderGenericFallback(
        container
      );

      return;

    }


    const marketTeams =
      getMarketTeams(
        market
      );


    container.innerHTML = `

      <div
        class="hm-geo-wrapper"
      >


        <section
          class="hm-geo-featured"
        >

          <div
            class="hm-geo-featured-intro"
          >

            <p
              class="hm-geo-eyebrow"
            >
              PICKED FOR YOUR AREA
            </p>


            <h2
              class="hm-geo-primary-team-title"
            >
              ${primaryTeam.name}
            </h2>


            <p
              class="hm-geo-subtext"
            >
              Fan favorites selected based on your location.
            </p>

          </div>


          <div
            class="hm-geo-carousel-shell"
          >

            <div
              id="hm-geo-products"
              class="hm-geo-product-carousel"
            >
            </div>


            <div
              class="hm-geo-primary-cta-wrap"
            >

              <a
                class="hm-geo-primary-cta"
                href="/collections/${primaryTeam.handle}"
              >

                Shop ${primaryTeam.name}

                <span
                  aria-hidden="true"
                >
                  →
                </span>

              </a>

            </div>


            <div
              id="hm-geo-carousel-controls"
              class="hm-geo-carousel-controls"
            >

              <button
                class="hm-geo-carousel-arrow hm-geo-carousel-prev"
                type="button"
                aria-label="Previous products"
              >
                &#8249;
              </button>


              <button
                class="hm-geo-carousel-arrow hm-geo-carousel-next"
                type="button"
                aria-label="Next products"
              >
                &#8250;
              </button>

            </div>

          </div>

        </section>


        <section
          class="hm-geo-other-teams"
        >

          <div
            class="hm-geo-section-heading"
          >

            <h3>
              Not Your Team?
            </h3>

            <p>
              Explore other teams recommended for your area.
            </p>

          </div>


          <div
            class="hm-geo-team-grid"
          >

            ${
              buildTeamButtons(
                marketTeams,
                primaryTeam.handle
              )
            }

          </div>

        </section>


        <section
          class="hm-geo-shop-all"
        >

          <div
            class="hm-geo-section-heading"
          >

            <h3>
              Shop All Teams
            </h3>

          </div>


          <div
            class="hm-geo-league-grid"
          >
            ${buildLeagueButtons()}
          </div>

        </section>


      </div>

    `;


    container.classList.remove(
      'geoswap-hide'
    );


    try {

      const products =
        await fetchCollectionProducts(
          primaryTeam.handle
        );


      const productContainer =
        document.getElementById(
          'hm-geo-products'
        );


      const carouselControls =
        document.getElementById(
          'hm-geo-carousel-controls'
        );


      if (!productContainer) {

        return;

      }


      if (
        products &&
        products.length
      ) {

        productContainer.innerHTML =
          buildProductCards(
            products
          );


        if (
          products.length > 1
        ) {

          initializeCarousel();

        } else if (
          carouselControls
        ) {

          carouselControls.style.display =
            'none';

        }

      }


      else {

        productContainer.innerHTML = `

          <div
            class="hm-geo-product-fallback"
          >

            <p>
              Explore our ${primaryTeam.name} collection.
            </p>

          </div>

        `;


        if (
          carouselControls
        ) {

          carouselControls.style.display =
            'none';

        }

      }


    } catch (error) {

      console.error(
        'HM Geo: Product loading failed.',
        error
      );


      const carouselControls =
        document.getElementById(
          'hm-geo-carousel-controls'
        );


      if (
        carouselControls
      ) {

        carouselControls.style.display =
          'none';

      }

    }

  }


  /* ============================================================
     15. CAROUSEL
     ============================================================ */

  function initializeCarousel() {

    const carousel =
      document.getElementById(
        'hm-geo-products'
      );


    const previous =
      document.querySelector(
        '.hm-geo-carousel-prev'
      );


    const next =
      document.querySelector(
        '.hm-geo-carousel-next'
      );


    if (
      !carousel ||
      !previous ||
      !next
    ) {

      return;

    }


    function getScrollAmount() {

      const card =
        carousel.querySelector(
          '.hm-geo-product-card'
        );


      if (!card) {

        return (
          carousel.clientWidth *
          0.8
        );

      }


      return (
        card
          .getBoundingClientRect()
          .width +
        18
      );

    }


    previous.addEventListener(
      'click',
      function () {

        carousel.scrollBy({

          left:
            -getScrollAmount(),

          behavior:
            'smooth'

        });

      }
    );


    next.addEventListener(
      'click',
      function () {

        carousel.scrollBy({

          left:
            getScrollAmount(),

          behavior:
            'smooth'

        });

      }
    );

  }


  /* ============================================================
     16. STYLES
     ============================================================ */

  function addStyles() {

    if (
      document.getElementById(
        'hm-geo-styles'
      )
    ) {

      return;

    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'hm-geo-styles';


    style.textContent = `

      #hm-geo-team-content {
        width: 100%;
      }


      .hm-geo-wrapper {
        max-width: 1200px;
        margin: 0 auto;
        padding: 56px 24px 72px;
        color: #111111;
      }


      .hm-geo-featured {
        margin-bottom: 64px;
      }


      .hm-geo-other-teams {
        margin-bottom: 56px;
      }


      .hm-geo-shop-all {
        margin-bottom: 20px;
      }


      /*
       * FEATURED INTRO
       */

      .hm-geo-featured-intro {
        margin-bottom: 30px;
      }


      .hm-geo-eyebrow {
        margin: 0 0 8px;
        font-size: 11px;
        line-height: 1.3;
        font-weight: 700;
        letter-spacing: 0.15em;
        text-transform: uppercase;
      }


      .hm-geo-primary-team-title {
        margin: 0;
        font-size: 30px;
        line-height: 1.15;
        font-weight: 500;
        letter-spacing: 0.01em;
        text-transform: uppercase;
      }


      .hm-geo-subtext {
        max-width: 520px;
        margin: 10px 0 0;
        font-size: 15px;
        line-height: 1.55;
      }


      /*
       * PRODUCT CAROUSEL
       */

      .hm-geo-product-carousel {
        display: flex;
        gap: 18px;
        width: 100%;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        scrollbar-width: none;
        overscroll-behavior-inline: contain;
        padding: 2px 2px 14px;
      }


      .hm-geo-product-carousel::-webkit-scrollbar {
        display: none;
      }


      .hm-geo-product-card {
        flex: 0 0 calc(25% - 14px);
        min-width: 0;
        color: inherit;
        text-decoration: none;
        scroll-snap-align: start;
      }


      .hm-geo-product-image-frame {
        width: 100%;
        aspect-ratio: 1 / 1;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        overflow: hidden;
        padding: 12px;
        background: #ffffff;
        border: 1px solid #e5e5e5;
      }


      .hm-geo-product-image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }


      .hm-geo-product-info {
        padding: 14px 2px 0;
      }


      .hm-geo-product-title {
        display: -webkit-box;
        min-height: 42px;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-size: 14px;
        line-height: 1.45;
        font-weight: 600;
      }


      .hm-geo-product-price {
        margin-top: 8px;
        font-size: 14px;
        line-height: 1.3;
      }


      /*
       * SHOP PRIMARY TEAM
       */

      .hm-geo-primary-cta-wrap {
        display: flex;
        justify-content: center;
        margin-top: 24px;
      }


      .hm-geo-primary-cta {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        min-height: 44px;
        padding: 12px 26px;
        border: 2px solid #101f60;
        border-radius: 999px;
        background: #101f60;
        color: #ffffff !important;
        text-decoration: none !important;
        font-size: 13px;
        line-height: 1.2;
        font-weight: 600;
      }


      .hm-geo-primary-cta:hover {
        background: #ffffff;
        color: #101f60 !important;
      }


      /*
       * ARROWS
       */

      .hm-geo-carousel-controls {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 22px;
        margin-top: 7px;
      }


      .hm-geo-carousel-arrow {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 46px;
        height: 46px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #101f60;
        font-size: 32px;
        cursor: pointer;
      }


      /*
       * SECTION TITLES
       */

      .hm-geo-section-heading {
        margin-bottom: 22px;
      }


      .hm-geo-section-heading h3 {
        margin: 0;
        font-size: 22px;
        line-height: 1.25;
        font-weight: 500;
        text-transform: uppercase;
      }


      .hm-geo-section-heading p {
        margin: 8px 0 0;
        font-size: 14px;
        line-height: 1.5;
      }


      /*
       * ========================================================
       * NOT YOUR TEAM
       *
       * WHITE BACKGROUND
       * NAVY BORDER
       * NAVY TEXT
       * HOVER = SHADOW ONLY
       * ========================================================
       */

      .hm-geo-team-grid {
        display: grid;
        grid-template-columns:
          repeat(4, minmax(0, 1fr));
        gap: 12px;
      }


      .hm-geo-team-button {
        display: flex;
        min-height: 64px;
        align-items: center;
        justify-content: flex-start;
        gap: 13px;

        box-sizing: border-box;

        padding: 9px 18px;

        border:
          2px solid #101f60;

        border-radius: 999px;

        background: #ffffff;

        color:
          #101f60 !important;

        text-decoration:
          none !important;

        box-shadow: none;

        transition:
          box-shadow 0.2s ease;
      }


      /*
       * Shadow only.
       * No movement.
       * No background/color change.
       */

      .hm-geo-team-button:hover {
        background: #ffffff;
        color: #101f60 !important;

        box-shadow:
          0 5px 16px
          rgba(16, 31, 96, 0.20);
      }


      /*
       * TEAM LOGO
       */

      .hm-geo-team-logo-wrap {
        display: flex;

        flex:
          0 0 42px;

        width: 42px;
        height: 42px;

        align-items: center;
        justify-content: center;

        background: transparent;

        overflow: hidden;
      }


      .hm-geo-team-logo {
        display: block;

        width: 38px;
        height: 38px;

        object-fit: contain;
      }


      /*
       * TEAM NAME
       */

      .hm-geo-team-name {
        min-width: 0;

        color: #101f60;

        font-size: 15px;
        line-height: 1.25;
        font-weight: 600;

        text-align: left;
      }


      /*
       * ========================================================
       * SHOP ALL TEAMS
       *
       * SIMPLE TEXT PILL BUTTONS:
       * NFL / MLB / NHL / NBA / College
       * ========================================================
       */

      .hm-geo-league-grid {
        display: flex;
        flex-wrap: wrap;

        justify-content: center;
        align-items: center;

        gap: 10px;

        margin-top: 18px;
      }


      .hm-geo-league-button {
        display: inline-flex;

        min-width: 92px;
        min-height: 42px;

        align-items: center;
        justify-content: center;

        box-sizing: border-box;

        padding: 10px 20px;

        border: 2px solid #101f60;
        border-radius: 999px;

        background: #ffffff;

        color: #101f60 !important;

        text-decoration: none !important;

        font-size: 12px;
        line-height: 1.2;
        font-weight: 600;

        text-align: center;

        transition:
          background-color 0.2s ease,
          color 0.2s ease;
      }


      .hm-geo-league-button:hover {
        background: #101f60;

        color: #ffffff !important;
      }


      /*
       * FALLBACK
       */

      .hm-geo-generic {
        text-align: center;
      }


      .hm-geo-generic h2 {
        margin: 0;
        font-size: 28px;
        font-weight: 500;
        text-transform: uppercase;
      }


      .hm-geo-generic p {
        margin: 12px auto 0;
        max-width: 520px;
        font-size: 15px;
        line-height: 1.5;
      }


      /*
       * TABLET
       */

      @media screen and (max-width: 989px) {

        .hm-geo-wrapper {
          padding: 48px 20px 64px;
        }


        .hm-geo-product-card {
          flex-basis:
            calc(33.333% - 12px);
        }


        .hm-geo-team-grid {
          grid-template-columns:
            repeat(2, minmax(0, 1fr));
        }

      }


      /*
       * MOBILE
       */

      @media screen and (max-width: 749px) {

        .hm-geo-wrapper {
          padding: 46px 7px 54px;
        }


        .hm-geo-featured {
          margin-bottom: 54px;
        }


        .hm-geo-other-teams {
          margin-bottom: 50px;
        }


        .hm-geo-featured-intro {
          margin-bottom: 26px;
        }


        .hm-geo-eyebrow {
          font-size: 10px;
        }


        .hm-geo-primary-team-title {
          font-size: 25px;
        }


        .hm-geo-subtext {
          font-size: 14px;
        }


        /*
         * PRODUCTS
         */

        .hm-geo-product-carousel {
          gap: 14px;
        }


        .hm-geo-product-card {
          flex-basis: 72%;
        }


        .hm-geo-product-title {
          font-size: 13px;
        }


        .hm-geo-product-price {
          font-size: 13px;
        }


        /*
         * CTA
         */

        .hm-geo-primary-cta-wrap {
          margin-top: 22px;
        }


        .hm-geo-primary-cta {
          min-height: 44px;
          padding: 12px 22px;
          font-size: 12px;
        }


        /*
         * HEADINGS
         */

        .hm-geo-section-heading h3 {
          font-size: 19px;
        }


        .hm-geo-section-heading p {
          font-size: 13px;
        }


        /*
         * ======================================================
         * MOBILE TEAM BUTTONS
         *
         * REMAIN PILL SHAPED.
         * ======================================================
         */

        .hm-geo-team-grid {
          grid-template-columns:
            repeat(2, minmax(0, 1fr));

          gap: 10px;
        }


        .hm-geo-team-button {
          min-height: 64px;

          gap: 9px;

          padding:
            8px 11px;

          border-radius:
            999px;

          background:
            #ffffff;

          color:
            #101f60 !important;
        }


        .hm-geo-team-button:hover {
          background:
            #ffffff;

          color:
            #101f60 !important;

          box-shadow:
            0 5px 16px
            rgba(16, 31, 96, 0.20);
        }


        .hm-geo-team-logo-wrap {
          flex-basis: 38px;

          width: 38px;
          height: 38px;
        }


        .hm-geo-team-logo {
          width: 34px;
          height: 34px;
        }


        .hm-geo-team-name {
          font-size: 13px;

          line-height: 1.2;
        }


        /*
         * SHOP ALL TEAMS - MOBILE
         */

        .hm-geo-league-grid {
          gap: 8px;

          margin-top: 18px;
        }


        .hm-geo-league-button {
          min-width: 86px;
          min-height: 40px;

          padding: 9px 16px;

          font-size: 11px;
        }

      }


      /*
       * VERY SMALL PHONE
       */

      @media screen and (max-width: 359px) {

        .hm-geo-team-grid {
          grid-template-columns:
            1fr;
        }


        .hm-geo-team-button {
          min-height: 60px;

          border-radius:
            999px;
        }


        .hm-geo-product-card {
          flex-basis: 82%;
        }


        .hm-geo-league-grid {
          gap: 7px;
        }


        .hm-geo-league-button {
          min-width: 80px;

          padding: 8px 13px;
        }

      }

    `;


    document.head.appendChild(
      style
    );

  }


  /* ============================================================
     17. INITIALIZE
     ============================================================ */

  function initializeGeoSports() {

    const container =
      document.getElementById(
        'hm-geo-team-content'
      );


    if (!container) {

      return;

    }


    container.innerHTML = '';

    container.classList.remove(
      'geoswap-hide'
    );


    addStyles();


    let attempts = 0;

    const maxAttempts = 40;


    const timer =
      setInterval(
        function () {

          attempts++;


          const location =
            getLocationData();


          if (location) {

            clearInterval(
              timer
            );


            const marketKey =
              resolveMarket(
                location
              );


            console.log(
              'HM GEO LOCATION:',
              location
            );


            console.log(
              'HM GEO MARKET:',
              marketKey
            );


            if (marketKey) {

              renderMarket(
                container,
                marketKey
              );

            }


            else {

              renderGenericFallback(
                container
              );

            }


            return;

          }


          if (
            attempts >=
            maxAttempts
          ) {

            clearInterval(
              timer
            );


            console.log(
              'HM Geo: No location available.'
            );


            renderGenericFallback(
              container
            );

          }

        },

        250
      );

  }


  /* ============================================================
     18. START
     ============================================================ */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeGeoSports
    );

  } else {

    initializeGeoSports();

  }

})();